import { Link } from 'react-router-dom'
import { useState } from 'react'

function News() {
    const [showSubscribeModal, setShowSubscribeModal] = useState(false)

    return (
        <>
            <div className="bg-white pb-8">
                <div className="max-w-2xl mx-auto px-4 py-16">
                    <div className="space-y-6 text-gray-700 leading-relaxed">
                        <h1 className="text-2xl font-medium text-gray-900 mb-8">
                            News
                        </h1>

                        <p>
                            We're working on something here. Stay tuned.
                        </p>

                        <p>
                            In the meantime, if you want to stay updated on what we're building, you can{' '}
                            <button
                                onClick={() => setShowSubscribeModal(true)}
                                className="text-gray-900 hover:text-gray-600 transition-colors underline"
                            >
                                subscribe to our newsletter
                            </button>
                            .
                        </p>

                        <div className="pt-8 mt-8 border-t border-gray-200">
                            <Link
                                to="/"
                                className="text-gray-900 hover:text-gray-600 transition-colors underline"
                            >
                                ← Back to jobs
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            {/* Subscribe Modal */}
            {showSubscribeModal && (
                <div
                    className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
                    onClick={() => setShowSubscribeModal(false)}
                >
                    <div
                        className="bg-white rounded-lg shadow-xl relative max-w-[520px] w-full"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Close Button */}
                        <button
                            onClick={() => setShowSubscribeModal(false)}
                            className="absolute -top-3 -right-3 bg-white rounded-full p-2 shadow-lg hover:bg-gray-50 transition-colors z-10"
                            aria-label="Close"
                        >
                            <svg className="w-5 h-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>

                        {/* Substack Embed */}
                        <iframe
                            src="https://signed.substack.com/embed"
                            width="100%"
                            height="320"
                            style={{ border: '1px solid #EEE', background: 'white', borderRadius: '0.5rem' }}
                            frameBorder="0"
                            scrolling="no"
                            title="Subscribe to Signed newsletter"
                        />
                    </div>
                </div>
            )}
        </>
    )
}

export default News
